import { CheckoutState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import CheckoutItem from "./interfaces/checkoutItem";
import ServiceItem from "./interfaces/serviceItem";
// @ts-ignore
import { getField } from 'vuex-map-fields';
import { AvailableCarExtra } from "./interfaces/availableCarExtra";
import { FARE_DEFAULT, FARE_FLEX, FARE_SMART } from "@constants/fares";
import { BOOKING_STEPS } from "@constants/steps";
import { AssistComments } from "@store/checkout/interfaces/assistComments";
import TripData from "@store/checkout/interfaces/tripData";
import { PAYMENT_GATEWAY, PAYMENT_REDIRECT } from "@constants/api";
import { EN_GB } from "@constants/locale";

export default {
    getField,
    getCarRentals(state): CheckoutItem[] {
        return state.checkoutSummary.carRentals;
    },
    carExtrasAmount: (state) => (extra: string) => {
        const result = state.checkoutSummary.carRentals.find((carExtra: CheckoutItem) => carExtra.id === extra);
        return result !== undefined ? result.amount : 0;
    },
    serviceAmount: (state) => (availableService: ServiceItem) => {
        const result = state.checkoutSummary.services.find((service: CheckoutItem) => service && service.id === availableService.id);
        return result !== undefined ? result.amount : 0;
    },
    getAccommodationUpgrades(state): CheckoutItem[] {
        return state.checkoutSummary.hotelUpgrades;
    },
    hasOnSitePriceItems: (state) => (items: AvailableCarExtra[] | ServiceItem[]): boolean => {
        return items.some(item => item.onSitePrice);
    },
    getCarUpgradeIds(state): string[] {
        const list: string[] = [];

        if (state.checkoutSummary.carRentals === null) {
            return list;
        }

        state.checkoutSummary.carRentals.forEach((upgrade: CheckoutItem) => {
            list.push(upgrade.id);
        })

        return list;
    },
    isOnRequest(state): boolean {
        return state.priceSummary.costItems.some(item => item.costType === 'OnRequest')
    },
    isDirectCheckout(state): boolean {
        return state.checkoutSettings.bindingMode === 'direct';
    },
    getBindingMode(state): string {
        return state.checkoutSettings.bindingMode;
    },
    onlyNonBinding(state): boolean {
        return state.isOnlyNonBinding;
    },
    getPayment(state): boolean {
        return state.hasPayment;
    },
    totalPrice(state): number {
        return state.priceSummary.totalPrice;
    },
    openAmountForPayment(state): number {
        return state.priceSummary.openAmount !== null ? state.priceSummary.openAmount : state.priceSummary.totalPrice;
    },
    openAmountForPaymentInquiry(state, _, rootState, rootGetters): number {
        let openAmount = state.priceSummary.openAmount !== null ? state.priceSummary.openAmount : state.priceSummary.totalPrice;

        if (state.checkoutSettings.stageIdent === 'tourradar') {
            // @ts-ignore
            const tourradarPrice: number = rootGetters['checkout/getTourradarBookedPrice'];
            openAmount = tourradarPrice > 0 ? tourradarPrice : openAmount;
        }

        return openAmount;
    },
    goToExpose(state): boolean {
        return state.preInquiry.bookingStep === 'expose';
    },
    isModalVisible(state): boolean {
        return Object.values(state.visibility).some((modal) => modal.isVisible === true);
    },
    isFarePreselected: (state) => (fare: string ): boolean => {
        return state.fare === fare;
    },
    hasFare(state): boolean {
        return state.priceSummary.fare !== FARE_DEFAULT && state.priceSummary.fare !== '';
    },
    getLoadingTexts(state): string[] {
        return state.loading.loadingTexts;
    },
    isAgency(state): boolean {
        return state.whitelabelSettings.agency;
    },
    /**
     * The current booking step is needed for restoring. Since no personal data is stored when saving the booking or
     * creating a paxconnect offer, the booking step given can be at least 'personalData'.
     */
    getCurrentBookingStep(state): string {
        return state.activeNavigation === BOOKING_STEPS.overview || state.activeNavigation === BOOKING_STEPS.payment
            ? BOOKING_STEPS.personalData
            : state.activeNavigation;
    },
    isBottomSheetActive(state): boolean {
        return state.isBottomSheetOpen;
    },
    isFareFlex(state): boolean {
        return state.priceSummary.fare === FARE_FLEX;
    },
    isSmartFare(state): boolean {
        return state.priceSummary.fare === FARE_SMART;
    },
    isIframe(state): boolean {
        return state.whitelabelSettings.isIframe;
    },
    hasAssistComments(state): boolean {
        return Object.values(state.assistComments).some((comment) => comment !== '');
    },
    getAssistComments(state): AssistComments {
        return state.assistComments;
    },
    anyError(state): boolean {
        return state.sessionIdError;
    },
    hasAdditionalField(state): boolean {
        return state.whitelabelSettings.additionalField.text !== '' && state.whitelabelSettings.additionalField.name !== '';
    },
    getPaymentRedirectUrl(state): string {
        const baseUrl = state.siteSettings.baseUrl;

        return baseUrl.replace(/\/*$/, '') + state.siteSettings.basePath + PAYMENT_REDIRECT;
    },
    paymentGatewayApi(state): string {
        const baseUrl = state.siteSettings.baseUrl;

        return baseUrl.replace(/\/*$/, '') + state.siteSettings.basePath + PAYMENT_GATEWAY;
    },
    getTripDataForAdyen(state): TripData {
        return {
            productUrl: state.checkoutSettings.trip.productUrl,
            imageUrl: state.checkoutSettings.trip.imageUrl,
            title: state.checkoutSettings.trip.title,
        };
    },
    getExposeLink: (state) => (segment: string): string => {
        const exposeLink: string = state.checkoutSettings.trip.productUrl;
        return exposeLink + '#' + segment;
    },
    isTourradar(state): boolean {
        return state.checkoutSettings.stageIdent === 'tourradar';
    },
    isUK(state): boolean {
        return state.checkoutSettings.locale === EN_GB;
    }
} as GetterTree<CheckoutState, IStore>
